import { Typography } from "@mui/material"
import { PriceItemDto } from "api"
import { formatPrice } from "common/price"
import { Font } from "components/shopFeatures/wizard/constants"
import styled, { css } from "styled-components"

const StyledContainer = styled.div`
  margin: ${(p) => p.theme.spacing(1, 0)};
  margin-bottom: 12px;
`
const StyledLabel = styled.span<{ $final?: boolean; $finalDiscount?: boolean }>`
  font-size: 14px;
  font-family: ${Font.OENaPro};
  font-weight: 300;
  line-height: 1.4;
  letter-spacing: 0em;
  ${(p) =>
    p.$final
      ? css`
          font-weight: 400;
          font-size: 18px;
        `
      : ""}
  ${(p) =>
    p.$finalDiscount
      ? css`
          font-weight: 400;
        `
      : ""}
`
const StyledPrice = styled.span<{
  $original?: boolean
  $final?: boolean
  $finalDiscount?: boolean
}>`
  margin-right: ${(p) => p.theme.spacing(1)}px;
  letter-spacing: 0.64px;
  color: ${(p) => p.theme.palette.text.primary};
  font-size: ${(p) => (p.$final ? "16px" : "14px")};
  direction: ltr;
  ${(p) =>
    p.$finalDiscount || p.$final
      ? css`
          font-weight: 400;
        `
      : ""}
  ${(p) =>
    p.$original &&
    css`
      font-size: 12px;
      margin-right: auto;
      text-decoration: line-through;
    `}
`
const StyledRow = styled.div<{ $final?: boolean; $finalDiscount?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(p) =>
    p.$finalDiscount || p.$final
      ? css`
          font-weight: 400;
        `
      : ""}
`

const StyledTitle = styled(Typography).attrs({
  variant: "h6",
  // component: "h3",
})`
  margin-bottom: ${(p) => p.theme.spacing(1)};
  font-size: 10px;
`

type PriceDetailProps = {
  label: string
  price: PriceItemDto | number
  final?: boolean
  finalDiscount?: boolean
  title?: string
}

const PriceDetail = ({
  label,
  price,
  final,
  finalDiscount,
  title,
}: PriceDetailProps) => (
  <StyledContainer>
    {title && <StyledTitle>{title}</StyledTitle>}
    <StyledRow
      $final={final}
      $finalDiscount={finalDiscount}
      role={finalDiscount ? "alert" : undefined}
    >
      <StyledLabel $final={final} $finalDiscount={finalDiscount}>
        {label}
      </StyledLabel>
      {final && typeof price === "object" && price.discount > 0 && (
        <StyledPrice $original title="מחיר לפני ההנחה">
          {formatPrice(price.originalPrice)}
        </StyledPrice>
      )}
      <StyledPrice
        title="מחיר נוכחי"
        $final={final}
        $finalDiscount={finalDiscount}
      >
        {formatPrice(typeof price === "object" ? price.totalPrice : price)}
      </StyledPrice>
    </StyledRow>
  </StyledContainer>
)

export default PriceDetail
